import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ClockIcon, SparklesIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProgramSection() {
  const bonuses = [{
    num: 1,
    title: 'Cómo Crear Tiempo Cuando No Tienes Tiempo',
    value: '$47',
    desc: 'Aprende el sistema mental que usan las personas organizadas para encontrar tiempo incluso en días caóticos.',
    image: 'https://cdn.magicpatterns.com/uploads/8Ugp3L9B7JcwU7KHCsn4ji/Gemini_Generated_Image_knn3z0knn3z0knn3.png'
  }, {
    num: 2,
    title: 'Kit de Plantillas Listas para Usar',
    value: '$37',
    desc: 'Plantillas simples para organizar tu semana, tus prioridades y tu mente sin tener que empezar desde cero.',
    image: 'https://cdn.magicpatterns.com/uploads/fuqsWxqXz7MK6GE8t8fDmi/Gemini_Generated_Image_nlb9ufnlb9ufnlb9.png'
  }, {
    num: 3,
    title: 'Sistema "Emergencia Total"',
    value: '$27',
    desc: 'Un protocolo rápido para esos días en los que todo se desordena y necesitas recuperar el control inmediato.',
    image: 'https://cdn.magicpatterns.com/uploads/kgRsXEWMDDXTQzAuTF3wQx/Gemini_Generated_Image_8bukte8bukte8buk.png'
  }, {
    num: 4,
    title: 'Comidas Fáciles en 15 Minutos',
    value: '$27',
    desc: 'Ideas de comidas rápidas para evitar el estrés diario de "¿Qué cocino hoy?"',
    image: 'https://cdn.magicpatterns.com/uploads/uqKab6usyMPUErchxABEao/Gemini_Generated_Image_xlkn94xlkn94xlkn.png'
  }, {
    num: 5,
    title: 'Guía para Eliminar la Culpa de Mamá Productiva',
    value: '$47',
    desc: 'Un sistema emocional para dejar de sentir que nunca haces suficiente.',
    image: 'https://cdn.magicpatterns.com/uploads/4DyAmMDVTDMyFBucVmH8yP/Gemini_Generated_Image_ks5i52ks5i52ks5i.png'
  }];
  return <section className="py-20 bg-beige md:py-32" data-id="element-165">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" data-id="element-166">
        {/* Qué Incluye Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="max-w-4xl mx-auto mb-24" data-id="element-167">
          <motion.h2 variants={itemVariants} className="mb-12 text-3xl font-bold text-center md:text-4xl text-charcoal font-playfair" data-id="element-168">
            Dentro de este ebook descubrirás:
          </motion.h2>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-169">
            {[{
            title: 'El sistema 10–3–1',
            desc: 'para organizar tu día en minutos.'
          }, {
            title: 'La regla 70%',
            desc: 'que elimina la sobrecarga mental.'
          }, {
            title: 'El método Semana Bajo Control',
            desc: 'para planificar sin estrés.'
          }, {
            title: 'El sistema Reset 24h',
            desc: 'para reiniciar cuando todo se desordena.'
          }].map((feature, index) => <motion.div key={index} variants={itemVariants} className="p-6 bg-white shadow-sm rounded-2xl border border-sage-light/20" data-id="element-170">
                <BookOpenIcon className="w-8 h-8 mb-4 text-sage" data-id="element-171" />
                <h4 className="mb-2 text-xl font-bold text-charcoal font-playfair" data-id="element-172">
                  {feature.title}
                </h4>
                <p className="text-charcoal/80" data-id="element-173">{feature.desc}</p>
              </motion.div>)}
            <motion.div variants={itemVariants} className="p-6 bg-sage rounded-2xl md:col-span-2 text-white flex items-center justify-center text-center shadow-md" data-id="element-174">
              <SparklesIcon className="w-6 h-6 mr-3 text-sage-light" data-id="element-175" />
              <p className="text-lg font-medium" data-id="element-176">
                Y herramientas prácticas que puedes aplicar desde el primer día.
              </p>
            </motion.div>
          </div>
        </motion.div>

        {/* Bonos Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-177">
          <div className="max-w-3xl mx-auto mb-16 text-center" data-id="element-178">
            <motion.h2 variants={itemVariants} className="mb-6 text-3xl font-bold md:text-4xl text-charcoal font-playfair" data-id="element-179">
              Pero eso no es todo…
            </motion.h2>
            <motion.p variants={itemVariants} className="text-xl text-charcoal/80" data-id="element-180">
              Para ayudarte a implementar este sistema más rápido, también
              recibirás{' '}
              <span className="font-bold text-sage" data-id="element-181">5 bonos exclusivos</span>.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8" data-id="element-182">
            {bonuses.map((bono, index) => <motion.div key={index} variants={itemVariants} className={`p-8 bg-white rounded-3xl shadow-sm border border-sage-light/30 relative overflow-hidden ${index === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto w-full' : ''}`} data-id="element-183">
                <div className="absolute top-0 right-0 w-32 h-32 transform translate-x-16 -translate-y-16 rounded-full bg-beige-warm" data-id="element-184"></div>

                <div className="relative z-10" data-id="element-185">
                  <span className="inline-block px-4 py-1.5 mb-5 text-sm font-bold tracking-wide rounded-full bg-sage-light/40 text-sage-dark" data-id="element-186">
                    BONO {bono.num}
                  </span>

                  {bono.image && <div className="mb-6 overflow-hidden rounded-2xl shadow-sm" data-id="element-187">
                      <img src={bono.image} alt={bono.title} className="w-full h-48 object-cover object-center" data-id="element-188" />
                    </div>}

                  <h4 className="mb-3 text-2xl font-bold leading-tight text-charcoal font-playfair" data-id="element-189">
                    {bono.title}
                  </h4>
                  <div className="flex items-center mb-4 text-sage" data-id="element-190">
                    <ClockIcon className="w-4 h-4 mr-2" data-id="element-191" />
                    <span className="font-semibold" data-id="element-192">Valor: {bono.value}</span>
                  </div>
                  <p className="text-lg leading-relaxed text-charcoal/80" data-id="element-193">
                    {bono.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}